import { gql } from "apollo-angular";

export default gql`
mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input:$input) {
    access_token
  }
}
`;
